import { useEffect, useMemo, useState } from "react";
import { Seller } from "src/types/sellers";
import { axiosInstance, endpoints } from "src/utils/axios";
import {
  groupSellersByPosition,
  RankedPosition,
} from "../utils/ranking-helpers";

interface UsePublicRankingParams {
  startDate?: string;
  endDate?: string;
}

export function usePublicRanking({ startDate, endDate }: UsePublicRankingParams = {}) {
  const [sellers, setSellers] = useState<Seller[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPublicSellers = async () => {
      try {
        setLoading(true);
        // Marca a requisição como pública para evitar redirecionamento
        const params: Record<string, unknown> = { perPage: 1000 };
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;

        const response = await axiosInstance.get(endpoints.sellers.getAll, {
          params,
          _isPublicRequest: true,
        } as any);
        setSellers(response.data?.items || []);
      } catch (error) {
        console.error("Erro ao buscar sellers públicos:", error);
        setSellers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPublicSellers();
  }, [startDate, endDate]);

  const rankedSellers = useMemo(() => {
    // Filtrar apenas sellers ativos e ordenar por userCount (maior para menor)
    return sellers
      .filter((seller) => seller.status === "active")
      .sort((a, b) => (b.userCount || 0) - (a.userCount || 0));
  }, [sellers]);

  const rankedPositions = useMemo(() => {
    return groupSellersByPosition(rankedSellers);
  }, [rankedSellers]);

  return {
    rankedSellers,
    rankedPositions,
    loading,
  };
}
